// import React, { useState, useEffect, useMemo } from 'react';
// import { Table, Button, Modal, Form, Input, InputNumber, message, Row, Col, Card, Statistic, DatePicker } from 'antd';
// import { PlusOutlined, DollarCircleOutlined, BarChartOutlined } from '@ant-design/icons';
// import dayjs from 'dayjs';
// import { expenseService } from '../../services/expensesService';

// interface Expense {
//   _id?: string;
//   label: string;
//   amount: number;
//   description?: string;
//   date: string;
// }

// const ExpensesManagement: React.FC = () => {
//   const [expenses, setExpenses] = useState<Expense[]>([]);
//   const [modalVisible, setModalVisible] = useState(false);
//   const [form] = Form.useForm();
//   const [editingExpense, setEditingExpense] = useState<Expense | null>(null);
//   const [dateFilter, setDateFilter] = useState<{ start?: dayjs.Dayjs; end?: dayjs.Dayjs }>({});

//   const token = localStorage.getItem('token') || '';

//   // 🔹 Charger toutes les dépenses
//   const loadExpenses = async () => {
//     try {
//       const data = await expenseService.getAllExpenses(token);
//       setExpenses(data);
//       console.log(data);
//     } catch (error) {
//       message.error('Erreur lors du chargement des dépenses');
//     }
//   };

//   useEffect(() => {
//     loadExpenses();
//   }, []);

//   // 🧮 Filtrer par date et calculer stats
//   const filteredExpenses = useMemo(() => {
//     return expenses.filter(exp => {
//       const expDate = dayjs(exp.date);
//       const { start, end } = dateFilter;
//       if (start && expDate.isBefore(start, 'day')) return false;
//       if (end && expDate.isAfter(end, 'day')) return false;
//       return true;
//     });
//   }, [expenses, dateFilter]);

//   const totalAmount = filteredExpenses.reduce((sum, e) => sum + e.amount, 0);
//   const averageAmount = filteredExpenses.length ? totalAmount / filteredExpenses.length : 0;

//   const openModal = (expense?: Expense) => {
//     setEditingExpense(expense || null);
//     setModalVisible(true);
//     if (expense) form.setFieldsValue({ ...expense, date: dayjs(expense.date) });
//     else form.resetFields();
//   };

//   const handleSubmit = async () => {
//     try {
//       const values = await form.validateFields();
//       const expenseData = { ...values, date: values.date.format('YYYY-MM-DD') };

//       if (editingExpense?._id) {
//         await expenseService.updateExpense(editingExpense._id, expenseData, token);
//         message.success('Dépense mise à jour avec succès');
//       } else {
//         await expenseService.createExpense(expenseData, token);
//         message.success('Dépense ajoutée avec succès');
//       }

//       setModalVisible(false);
//       form.resetFields();
//       loadExpenses();
//     } catch (error) {
//       message.error('Erreur lors de l’enregistrement de la dépense');
//     }
//   };

//   const handleDelete = async (id?: string) => {
//     if (!id) return;
//     try {
//       await expenseService.deleteExpense(id, token);
//       message.success('Dépense supprimée');
//       loadExpenses();
//     } catch (error) {
//       message.error('Erreur lors de la suppression de la dépense');
//     }
//   };

//   const columns = [
//     { title: 'Date', dataIndex: 'date', key: 'date', render: (d: string) => dayjs(d).format('YYYY-MM-DD') },
//     { title: 'Libellé', dataIndex: 'label', key: 'label' },
//     { title: 'Montant', dataIndex: 'amount', key: 'amount', render: (v: number) => `${v.toFixed(2)} FCFA` },
//     { title: 'Description', dataIndex: 'description', key: 'description' },
//     {
//       title: 'Actions',
//       key: 'actions',
//       render: (_: any, record: Expense) => (
//         <>
//           <Button type="link" onClick={() => openModal(record)}>Modifier</Button>
//           <Button type="link" danger onClick={() => handleDelete(record._id)}>Supprimer</Button>
//         </>
//       )
//     }
//   ];

//   return (
//     <div>
//       <h2 style={{ marginBottom: 16 }}>Gestion des Dépenses</h2>

//       {/* Statistiques */}
//       <Row gutter={16} style={{ marginBottom: 24 }}>
//         <Col xs={24} sm={8}><Card><Statistic title="Nombre de dépenses" value={filteredExpenses.length} prefix={<BarChartOutlined />} /></Card></Col>
//         <Col xs={24} sm={8}><Card><Statistic title="Total dépensé" value={totalAmount} precision={2} prefix={<DollarCircleOutlined />} suffix="FCFA" /></Card></Col>
//         <Col xs={24} sm={8}><Card><Statistic title="Dépense moyenne" value={averageAmount} precision={2} prefix={<DollarCircleOutlined />} suffix="FCFA" /></Card></Col>
//       </Row>

//       {/* Filtres et ajout */}
//       <Row gutter={16} style={{ marginBottom: 16 }}>
//         <Col><DatePicker placeholder="Date de début" onChange={d => setDateFilter(prev => ({ ...prev, start: d || undefined }))} /></Col>
//         <Col><DatePicker placeholder="Date de fin" onChange={d => setDateFilter(prev => ({ ...prev, end: d || undefined }))} /></Col>
//         <Col><Button type="primary" icon={<PlusOutlined />} onClick={() => openModal()}>Ajouter une dépense</Button></Col>
//       </Row>

//       {/* Tableau */}
//       <Table columns={columns} dataSource={filteredExpenses} rowKey="_id" pagination={{ pageSize: 5 }} />

//       {/* Modal */}
//       <Modal title={editingExpense ? 'Modifier la dépense' : 'Nouvelle dépense'} open={modalVisible} onCancel={() => setModalVisible(false)} onOk={handleSubmit} okText="Enregistrer" cancelText="Annuler">
//         <Form form={form} layout="vertical">
//           <Form.Item name="date" label="Date" rules={[{ required: true, message: 'Veuillez choisir une date' }]}><DatePicker style={{ width: '100%' }} /></Form.Item>
//           <Form.Item name="label" label="Libellé" rules={[{ required: true, message: 'Veuillez entrer un libellé' }]}><Input placeholder="Ex: Achat fournitures" /></Form.Item>
//           <Form.Item name="amount" label="Montant (FCFA)" rules={[{ required: true, message: 'Veuillez entrer un montant' }]}><InputNumber style={{ width: '100%' }} min={0} /></Form.Item>
//           <Form.Item name="description" label="Description"><Input.TextArea placeholder="Ex: Papier, stylos..." /></Form.Item>
//         </Form>
//       </Modal>
//     </div>
//   );
// };

// export default ExpensesManagement;

import React, { useState, useEffect, useMemo } from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  InputNumber,
  message,
  Row,
  Col,
  Card,
  Statistic,
  DatePicker,
  Select,
  Tag,
  Popconfirm,
} from "antd";
import { PlusOutlined, DollarCircleOutlined, BarChartOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { Pie } from "@ant-design/plots";
import { expenseService } from "../../services/expensesService";

interface Expense {
  _id?: string;
  label: string;
  amount: number;
  description?: string;
  date: string;
}

// 🎯 Catégories + couleurs
const CATEGORY_COLORS: Record<string, string> = {
  "Matières premières": "blue",
  "Maintenance": "red",
  "Fournitures": "purple",
  "Ressources humaines": "green",
  "Transport": "orange",
  "Autres": "gray",
};

// 🧠 Fonction de catégorisation intelligente
const autoDetectCategory = (label: string, description: string = "") => {
  const text = (label + " " + description).toLowerCase();

  const scores: Record<string, number> = {
    "Matières premières": 0,
    "Maintenance": 0,
    "Fournitures": 0,
    "Ressources humaines": 0,
    "Transport": 0,
    "Autres": 0,
  };

  const keywordMap: Record<string, string[]> = {
    "Matières premières": ["farine", "beurre", "sésame", "huile", "sucre", "lait", "avoine"],
    "Maintenance": ["réparation", "gaz", "four", "maintenance"],
    "Fournitures": ["pile", "colorant", "sachet", "emballage", "fourniture"],
    "Ressources humaines": ["salaires", "employés", "déjeuner", "personnel"],
    "Transport": ["transport", "essence"],
  };

  Object.keys(keywordMap).forEach((category) => {
    keywordMap[category].forEach((keyword) => {
      if (text.includes(keyword)) scores[category] += 1;
    });
  });

  // Catégorie avec meilleur score
  const bestCategory = Object.entries(scores).sort((a, b) => b[1] - a[1])[0];
  return bestCategory[1] === 0 ? "Autres" : bestCategory[0];
};

const ExpensesManagement: React.FC = () => {
  const [expenses, setExpenses] = useState<Expense[]>([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [editingExpense, setEditingExpense] = useState<Expense | null>(null);
  const [dateFilter, setDateFilter] = useState<{ start?: dayjs.Dayjs; end?: dayjs.Dayjs }>({});
  const [categoryFilter, setCategoryFilter] = useState<string | null>(null);
  const [search, setSearch] = useState("");

  const token = localStorage.getItem("token") || "";

  // Fetch data
  const loadExpenses = async () => {
    try {
      const data = await expenseService.getAllExpenses(token);
      setExpenses(data);
    } catch (error) {
      message.error("Erreur lors du chargement des dépenses");
    }
  };

  useEffect(() => {
    loadExpenses();
  }, []);

  // Filtrage complet
  const filteredExpenses = useMemo(() => {
    return expenses.filter((exp) => {
      const expDate = dayjs(exp.date);
      const { start, end } = dateFilter;

      if (start && expDate.isBefore(start, "day")) return false;
      if (end && expDate.isAfter(end, "day")) return false;

      const detected = autoDetectCategory(exp.label, exp.description);
      if (categoryFilter && detected !== categoryFilter) return false;

      if (search) {
        const text = (exp.label + " " + exp.description).toLowerCase();
        if (!text.includes(search.toLowerCase())) return false;
      }

      return true;
    });
  }, [expenses, dateFilter, categoryFilter, search]);

  const totalAmount = filteredExpenses.reduce((sum, e) => sum + e.amount, 0);
  const averageAmount = filteredExpenses.length ? totalAmount / filteredExpenses.length : 0;

  // Graphique catégories
  const pieData = useMemo(() => {
    const map: Record<string, number> = {};
    filteredExpenses.forEach((exp) => {
      const cat = autoDetectCategory(exp.label, exp.description);
      map[cat] = (map[cat] || 0) + exp.amount;
    });

    return Object.entries(map).map(([type, value]) => ({ type, value }));
  }, [filteredExpenses]);

  const pieConfig = {
    data: pieData,
    angleField: "value",
    colorField: "type",
    label: { type: "outer", content: "{name} {percentage}" },
  };

    const exportPDF = () => {
    const doc = new jsPDF();

    doc.setFontSize(18);
    doc.text("Rapport des Dépenses", 14, 20);

    doc.setFontSize(12);
    doc.text(`Généré le : ${dayjs().format("YYYY-MM-DD HH:mm")}`, 14, 30);

    if (dateFilter.start || dateFilter.end) {
      doc.text(
        `Période : ${dateFilter.start ? dateFilter.start.format("YYYY-MM-DD") : "----"}  →  ${
          dateFilter.end ? dateFilter.end.format("YYYY-MM-DD") : "----"
        }`,
        14,
        38
      );
    }

    doc.text(`Total dépensé: ${totalAmount.toFixed(2)} FCFA`, 14, 48);
    doc.text(`Dépense moyenne: ${averageAmount.toFixed(2)} FCFA`, 14, 56);

    autoTable(doc, {
      startY: 70,
      head: [["Date", "Libellé", "Catégorie", "Montant", "Description"]],
      body: filteredExpenses.map((exp) => [
        dayjs(exp.date).format("YYYY-MM-DD"),
        exp.label,
        autoDetectCategory(exp.label, exp.description),
        exp.amount.toFixed(2) + " FCFA",
        exp.description || "",
      ]),
    });

    doc.save("depenses.pdf");
  };

  const openModal = (expense?: Expense) => {
    setEditingExpense(expense || null);
    setModalVisible(true);
    if (expense) form.setFieldsValue({ ...expense, date: dayjs(expense.date) });
    else form.resetFields();
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const expenseData = { ...values, date: values.date.format("YYYY-MM-DD") };

      if (editingExpense?._id) {
        await expenseService.updateExpense(editingExpense._id, expenseData, token);
        message.success("Dépense mise à jour avec succès");
      } else {
        await expenseService.createExpense(expenseData, token);
        message.success("Dépense ajoutée avec succès");
      }

      setModalVisible(false);
      form.resetFields();
      loadExpenses();
    } catch (error) {
      message.error("Erreur lors de l’enregistrement");
    }
  };

  const handleDelete = async (id?: string) => {
    if (!id) return;
    try {
      await expenseService.deleteExpense(id, token);
      message.success("Dépense supprimée");
      loadExpenses();
    } catch {
      message.error("Erreur lors de la suppression");
    }
  };

  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (d: string) => dayjs(d).format("YYYY-MM-DD"),
    },
    {
      title: "Libellé",
      dataIndex: "label",
      key: "label",
    },
    {
      title: "Catégorie",
      key: "category",
      render: (_: any, record: Expense) => {
        const cat = autoDetectCategory(record.label, record.description);
        return <Tag color={CATEGORY_COLORS[cat]}>{cat}</Tag>;
      },
    },
    {
      title: "Montant",
      dataIndex: "amount",
      key: "amount",
      render: (v: number) => `${v.toFixed(2)} FCFA`,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_: any, record: Expense) => (
        <>
          <Button type="link" onClick={() => openModal(record)}>
            Modifier
          </Button>
          <Popconfirm
            title="Supprimer cette dépense ?"
            description="Cette action est définitive."
            okText="Supprimer"
            cancelText="Annuler"
            okButtonProps={{ danger: true }}
            onConfirm={() => handleDelete(record._id)}
          >
            <Button type="link" danger>
              Supprimer
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <h2 style={{ marginBottom: 16 }}>Gestion des Dépenses</h2>

      {/* Statistiques */}
      <Row gutter={16} style={{ marginBottom: 24 }}>
        <Col xs={24} sm={8}>
          <Card>
            <Statistic title="Nombre de dépenses" value={filteredExpenses.length} prefix={<BarChartOutlined />} />
          </Card>
        </Col>
        <Col xs={24} sm={8}>
          <Card>
            <Statistic
              title="Total dépensé"
              value={totalAmount}
              precision={2}
              prefix={<DollarCircleOutlined />}
              suffix="FCFA"
            />
          </Card>
        </Col>
        <Col xs={24} sm={8}>
          <Card>
            <Statistic
              title="Dépense moyenne"
              value={averageAmount}
              precision={2}
              prefix={<DollarCircleOutlined />}
              suffix="FCFA"
            />
          </Card>
        </Col>
      </Row>

      {/* Graphique */}
      {/* <Card title="Répartition par catégorie" style={{ marginBottom: 24 }}>
        <Pie {...pieConfig} />
      </Card> */}

      {/* Filtres */}
      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col>
          <DatePicker placeholder="Date de début" onChange={(d) => setDateFilter((p) => ({ ...p, start: d || undefined }))} />
        </Col>

        <Col>
          <DatePicker placeholder="Date de fin" onChange={(d) => setDateFilter((p) => ({ ...p, end: d || undefined }))} />
        </Col>

        <Col>
          {/* <Select
            placeholder="Filtrer catégorie"
            style={{ width: 200 }}
            allowClear
            onChange={(v) => setCategoryFilter(v || null)}
          >
            {Object.keys(CATEGORY_COLORS).map((cat) => (
              <Select.Option key={cat} value={cat}>
                {cat}
              </Select.Option>
            ))}
          </Select> */}

          <Select
  placeholder="Filtrer catégorie"
  style={{ width: 200 }}
  allowClear
  onChange={(v) => setCategoryFilter(v || null)}
  options={Object.keys(CATEGORY_COLORS).map((cat) => ({
    label: cat,
    value: cat
  }))}
/>
        </Col>

        <Col>
          <Input placeholder="Recherche..." style={{ width: 200 }} onChange={(e) => setSearch(e.target.value)} />
        </Col>

        <Col>
          <Button type="primary" icon={<PlusOutlined />} onClick={() => openModal()}>
            Ajouter une dépense
          </Button>
          <Button onClick={exportPDF} style={{ marginRight: 10 }}>
          Exporter PDF
        </Button>
        </Col>
      </Row>

      {/* Table */}
      <Table columns={columns} dataSource={filteredExpenses} rowKey="_id" pagination={{ pageSize: 5 }} />

      {/* Modal */}
      <Modal
        title={editingExpense ? "Modifier la dépense" : "Nouvelle dépense"}
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        onOk={handleSubmit}
        okText="Enregistrer"
        cancelText="Annuler"
      >
        <Form form={form} layout="vertical">
          <Form.Item name="date" label="Date" rules={[{ required: true }]}><DatePicker style={{ width: "100%" }} /></Form.Item>
          <Form.Item name="label" label="Libellé" rules={[{ required: true }]}><Input /></Form.Item>
          <Form.Item name="amount" label="Montant (FCFA)" rules={[{ required: true }]}><InputNumber min={0} style={{ width: "100%" }} /></Form.Item>
          <Form.Item name="description" label="Description"><Input.TextArea /></Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default ExpensesManagement;
